module.exports = __webpack_public_path__ + "static/img/download_qrcode.8621bf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_qrcode.png
// module id = yBta
// module chunks = 1